import { Button, Form } from 'react-bootstrap';

// Períodos de la Ley 24.476 (mes desde – mes hasta), como los maneja la pantalla: { desde: 'AAAA-MM',
// hasta: 'AAAA-MM' }. Para el backend van como 'AAAA-MM-01' (aFechaPeriodo).

export const mesesDePeriodo = ({ desde, hasta }) => {
    if (!desde || !hasta) return 0;
    const [a1, m1] = desde.split('-').map(Number);
    const [a2, m2] = hasta.split('-').map(Number);
    return Math.max(0, (a2 - a1) * 12 + (m2 - m1) + 1);
};
export const aMesPeriodo = (iso) => (iso ? String(iso).slice(0, 7) : '');
export const aFechaPeriodo = (mes) => (mes ? `${mes}-01` : null);
export const mesAnio = (iso) => {
    if (!iso) return '';
    const [a, m] = String(iso).slice(0, 7).split('-');
    return a && m ? `${m}/${a}` : iso;
};
export const periodoValido = (p) => Boolean(p.desde && p.hasta && mesesDePeriodo(p) > 0);

/** Períodos editables (varios, salteados), con el total de meses. */
export default function EditorPeriodos24476({ periodos, onChange, disabled, idBase = 'p24476' }) {
    const cambiar = (i, campo, valor) => onChange(periodos.map((p, j) => (j === i ? { ...p, [campo]: valor } : p)));
    const total = periodos.reduce((acc, p) => acc + mesesDePeriodo(p), 0);
    return (
        <div>
            {periodos.map((p, i) => (
                <div key={i} className="d-flex flex-wrap align-items-end gap-2 mb-2">
                    <div>
                        <label className="form-label small mb-0" htmlFor={`${idBase}-desde-${i}`}>Desde</label>
                        <Form.Control id={`${idBase}-desde-${i}`} type="month" size="sm" value={p.desde} disabled={disabled}
                            onChange={(e) => cambiar(i, 'desde', e.target.value)} />
                    </div>
                    <div>
                        <label className="form-label small mb-0" htmlFor={`${idBase}-hasta-${i}`}>Hasta</label>
                        <Form.Control id={`${idBase}-hasta-${i}`} type="month" size="sm" value={p.hasta} disabled={disabled}
                            onChange={(e) => cambiar(i, 'hasta', e.target.value)} />
                    </div>
                    <span className="text-muted small pb-1">
                        {p.desde && p.hasta && !mesesDePeriodo(p) ? 'Termina antes de empezar' : (mesesDePeriodo(p) ? `${mesesDePeriodo(p)} meses` : '')}
                    </span>
                    {!disabled && (
                        <Button variant="link" size="sm" className="text-danger pb-1" aria-label={`Quitar período ${i + 1}`}
                            onClick={() => onChange(periodos.filter((_, j) => j !== i))}>
                            <i className="bi bi-trash" />
                        </Button>
                    )}
                </div>
            ))}
            {!disabled && (
                <Button variant="outline-secondary" size="sm" onClick={() => onChange([...periodos, { desde: '', hasta: '' }])}>
                    <i className="bi bi-plus-lg me-1" />Agregar período
                </Button>
            )}
            {total > 0 && <div className="small text-muted mt-1">Total: {total} meses</div>}
        </div>
    );
}
